import { Injectable } from '@angular/core';
import { asyncScheduler, BehaviorSubject, distinctUntilChanged, observeOn } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private isloadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isLoading$ = this.isloadingSubject.asObservable().pipe(observeOn(asyncScheduler), distinctUntilChanged());

  startLoading() {
    this.isloadingSubject.next(true);
  }

  stopLoading() {
    this.isloadingSubject.next(false);
  }
}
